import {
  Alert,
  CardActions,
  CardHeader,
  Chip,
  Divider,
  Grid,
  Paper,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../shares/AppButton";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import { DeleteOutline, EditOutlined, InfoOutlined } from "@material-ui/icons";
import { CalendarMonthOutlined } from "@mui/icons-material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import ExperienceForm from "./forms/ExperienceForm";
import { CVService } from "../../../../service/CVService";
import { useQuery } from "../../../../hooks/useQuery";
import useConfirm from "../../../../hooks/useConfirm";
import useToast from "../../../../hooks/useToast";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";

export function calculeExperience(date_debut, date_fin) {
  let dateFin = date_fin ? new Date(date_fin) : new Date();
  let dateDebut = new Date(date_debut);
  try {
    const differenceInDays = dateFin.getDate() - dateDebut.getDate();
    const differenceInMonths =
      (dateFin.getFullYear() - dateDebut.getFullYear()) * 12 +
      (dateFin.getMonth() - dateDebut.getMonth());
    const differenceInYears = Math.floor(differenceInMonths / 12);
    const remainingMonths = differenceInMonths % 12;
    return {
      annee: differenceInYears,
      mois: remainingMonths + Number((differenceInDays / 30).toFixed(1)),
    };
  } catch (e) {
    console.error(
      "Erreur lors de la conversion des dates en experience. Erreur: ",
      e
    );
    return { annee: 0, mois: 0 };
  }
}

export function calculeTotalExperience(annee, mois) {
  const totalMois = annee * 12 + mois;
  const totalAnnee = Math.floor(totalMois / 12);
  const totalMoisRestant = totalMois % 12;
  return { annee: totalAnnee, mois: totalMoisRestant };
}

const ExperienceProfessionnels = () => {
  const [currentExperience, setCurrentExperience] = useState({});
  const [educationFormDialogOpen, setEducationFormDialogOpen] = useState(false);
  const [experiences, setExperiences] = useState([]);
  const query = useQuery();
  const id_identite = query.get("id_identite");
  const { DialogComponent, openConfirmDialog } = useConfirm();
  const { Toast, showToast } = useToast();

  const confirmDelete = (experience) => {
    CVService.deleteExperience(experience.id_experience).then((res) => {
      if (res && res.success) {
        showToast(TYPE_NOTIFICATION.SUCCESS, res.message);
        handleFetchExperience();
      } else {
        showToast(TYPE_NOTIFICATION.ERROR, res.message);
      }
    });
  };

  const handleDeleteExperience = (experience) => {
    openConfirmDialog(
      "Confirmation",
      "Voullez vous supprimer cette ligne?",
      () => confirmDelete(experience)
    );
  };

  const handleCloseExperienceForm = () => {
    setEducationFormDialogOpen(false);
    setCurrentExperience({});
    handleFetchExperience();
  };

  const handleFetchExperience = () => {
    CVService.getExperienceList({
      id_identite: id_identite,
    }).then((res) => {
      if (res && res.data) {
        setExperiences(res.data);
      }
    });
  };

  const handleCreateExperience = () => {
    setEducationFormDialogOpen(true);
    setCurrentExperience({});
  };
  const handleUpdateExperience = (experience) => {
    setEducationFormDialogOpen(true);
    setCurrentExperience(experience);
  };
  useEffect(() => {
    handleFetchExperience();
  }, []);
  return (
    <>
      <Toast />
      <ExperienceForm
        open={educationFormDialogOpen}
        onFormClose={handleCloseExperienceForm}
        idExperience={currentExperience.id_experience}
      />
      <DialogComponent />
      <Paper>
        <Grid item xs={12} width={"100%"}>
          <CardHeader
            sx={{ m: 2 }}
            title="Experiences professionnelles"
            action={
              <Grid>
                <AppButton
                  icon={<AddCircleOutlineOutlinedIcon />}
                  text={"Ajouter"}
                  variant={"outlined"}
                  onClick={handleCreateExperience}
                />
              </Grid>
            }
          />
          {experiences.length > 0 ? (
            experiences.map((item, index) => {
              const dateFin = item.date_fin_experience
                ? new Date(item.date_fin_experience)
                : new Date();
              const dateDebut = new Date(item.date_debut_experience);
              let experience = calculeExperience(
                item.date_debut_experience,
                item.date_fin_experience === "0000-00-00 00:00:00"
                  ? new Date()
                  : item.date_fin_experience
              );
              return (
                <Grid key={index}>
                  <ul>
                    <CardHeader
                      title={
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <li
                            style={{ fontSize: "20px" }}
                          >{`${item.experience_mission}`}</li>
                        </Stack>
                      }
                      subheader={
                        <Grid>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <CalendarMonthOutlined />
                            <span>
                              {`Periode : ${dateDebut.toLocaleDateString()} - ${item.date_fin_experience !== "0000-00-00 00:00:00" ? dateFin.toLocaleDateString() : "Actuel"} `}
                              <Chip
                                sx={{ mb: 0.5 }}
                                size="small"
                                variant="outlined"
                                color="primary"
                                label={`${experience.annee === 0 ? "" : experience.annee + " ans"}  ${experience.mois} mois`}
                              />
                            </span>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <BadgeOutlinedIcon />
                            <span>
                              <span>{`Statut : ${item.statut || ""}`}</span>
                            </span>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <BusinessIcon />
                            <span>
                              <span>{`Etablissement : ${item.organisme_experience || ""}`}</span>
                            </span>
                          </Stack>
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <span>
                              <SupervisorAccountOutlinedIcon />
                              <span>Reference :</span>
                              <ul>
                                <li>{`Nom : ${item.reference || ""}`}</li>
                                <li>{`Phone : ${item.num_ref || ""}`}</li>
                                <li>{`Email : ${item.email_ref || ""}`}</li>
                              </ul>
                            </span>
                          </Stack>

                          <Stack
                            direction="column"
                            alignItems="flex-start"
                            spacing={1}
                          >
                            <Stack
                              direction="row"
                              alignItems="flex-start"
                              spacing={1}
                            >
                              <DescriptionOutlinedIcon />
                              <span>{`Description:`}</span>
                            </Stack>
                            <CardHeader
                              subheader={`${item.description_experience || ""}`}
                            />
                          </Stack>
                        </Grid>
                      }
                    />
                    <CardActions sx={{ justifyContent: "flex-end", mr: 2 }}>
                      <AppButton
                        icon={<EditOutlined />}
                        text={"Modifier"}
                        variant={"outlined"}
                        onClick={(e) => handleUpdateExperience(item)}
                      />
                      <AppButton
                        icon={<DeleteOutline />}
                        text={"Supprimer"}
                        onClick={(e) => handleDeleteExperience(item)}
                        color={"warning"}
                        variant={"outlined"}
                      />
                    </CardActions>
                  </ul>
                  <Divider variant="middle" />
                </Grid>
              );
            })
          ) : (
            <Grid item p={3}>
              <Alert variant="outlined" color="info" icon={<InfoOutlined />}>
                {" "}
                Aucune information
              </Alert>
            </Grid>
          )}
        </Grid>
      </Paper>
    </>
  );
};

export default ExperienceProfessionnels;
